import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    let originatorUrl = this.data.get('url');
    $("#event_support_country").select2();
    $("#event_manager_country").select2();
    $("#event_originator_id").select2({
      ajax: {
        url: originatorUrl,
        dataType: 'json',
        delay: 250,
        results: function (data, page) {
          return {results: data};
        },
        processResults: function (data, params) {
          // parse the results into the format expected by Select2
          // since we are using custom formatting functions we do not need to
          // alter the remote JSON data, except to indicate that infinite
          // scrolling can be used
          return {
            // results: [{id: 1, text: 'Blah Blah'}]
            results: _.map(data, function(org){
              return {id: org.id, text: org.name};
            })
          }
        }
      }
    });
  }

  disconnect() {
    $("#event_support_country").select2('destroy');
    $("#event_manager_country").select2('destroy');
    $("#event_originator_id").select2('destroy');
  }
}
